import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setBearer } from '../../../../Services/AxiosService';
import { commonFeatures } from '../../featureFlags/commonFeatures';

const { isCA14196On_RefreshTokenBugFix } = commonFeatures;

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        accessToken: '',
        logout: false,
        activeStorageKey: '',
    },
    reducers: {
        setAccessToken: (
            state,
            action: PayloadAction<{
                accessToken: string;
                storageKey: string;
            }>,
        ) => {
            state.accessToken = action.payload.accessToken;
            setBearer(action.payload.accessToken);
            if (isCA14196On_RefreshTokenBugFix) {
                state.activeStorageKey = action.payload.storageKey;
            }
        },
        updateAccessTokenOnRefresh: (
            state,
            action: PayloadAction<{
                accessToken: string;
                storageKey: string;
            }>,
        ) => {
            if (state.activeStorageKey === action.payload.storageKey) {
                state.accessToken = action.payload.accessToken;
                setBearer(action.payload.accessToken);
            }
        },
        setLogout: state => {
            state.logout = true;
        },
    },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
